import { LoginForm } from '@bvi/dashboard/feature/auth/ui/login-form';

export const LoginPage = () => {
  return <LoginForm />;
};
